// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAccessToken  } from "./Api"; // unser axios-instance
import { authService } from "./services/authService";

function Login( {setIsLoggedIn} ) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

/*     try {
      // POST /api/authenticate
      const response = await api.post("/authenticate", {
        username: form.username,
        password: form.password
      });
      // Laut Go-Code erwartest du JSON mit "access_token" und "refresh_token"
      // In deinem Code heißt das Objekt TokenPairs => { "access_token", "refresh_token" }
      const { tokens} = response.data;

      // Speichere Access Token in localStorage
      //localStorage.setItem("access_token", access_token);
      setAccessToken(tokens.access_token)

      // Hier sagst du der App, dass wir nun eingeloggt sind:
      if (setIsLoggedIn) {
        setIsLoggedIn(true);
      }

      // Weiterleitung auf Startseite oder /einkauf
      navigate("/");
    } catch (err) {
      console.error("Login error", err);
      setError("Login fehlgeschlagen. Bitte prüfe Benutzername/Passwort.");
    } */
      const result = await authService.login(form.username, form.password);
  
      if (result.success) {
        // Login erfolgreich
        if (setIsLoggedIn) {
          setIsLoggedIn(true);
        }
        navigate("/");
      } else {
        // Login fehlgeschlagen
        setError(result.error);
      }

  };

  return (
    <div style={{ maxWidth: "400px", margin: "0 auto", padding: "20px" }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Benutzername</label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            className="form-control"
            required
            autoComplete="username"
          />
        </div>
        <div className="mb-3">
          <label>Passwort</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            className="form-control"
            required
            autoComplete="current-password"
          />
        </div>
        {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}
        <button type="submit" className="btn btn-primary">Einloggen</button>
      </form>
    </div>
  );
}

export default Login;
